import ErrorHandler from "../base/components/errorHandler";
import {Route, Routes} from "react-router";
import React from "react";
import CreateSalesRegister from "./page/create";
import EditSalesRegister from "./page/edit";
import ListSalesRegister from "./page/list";
import CounterpartyList from "./page/counterpartyList";


export default function() {
  return (
      <Routes>
        <Route path={"list"} element={<CounterpartyList/>} />
        <Route path={"list/:id"} element={<ListSalesRegister/>} />
        <Route path={"create"} element={<CreateSalesRegister/>} />
        <Route path={"edit/:id"} element={<EditSalesRegister/>} />

      </Routes>
  );
}
